import moment from 'moment';
import {http} from './http'

const getStatus = (date) => {
  let currentDate = moment().format('YYYY-MM-DD');
  date = moment(date).format('YYYY-MM-DD');
  if (date === currentDate) return 'SEDANG BERLANGSUNG'
  else if (date < currentDate) return 'SUDAH SELESAI'
  else return 'AKAN DATANG'
}
const getStatus2 = (date) => {
  let currentDate = moment().format('YYYY-MM-DD');
  date = moment(date).format('YYYY-MM-DD');
  if (date === currentDate) return 2
  else if (date < currentDate) return 3
  else return 1
}

const getToken = () => JSON.parse(localStorage.getItem('kominfo-psre'));
const getUserData = async () => {
  let user = JSON.parse(localStorage.getItem('kominfo-psre'));
  if (user !== null) {
    let params = {
      method:'GET',
      path:'profiles/'+user.email,
      showMessage: false
    }
    return await http(params);
  }
}

export {
  getStatus,
  getStatus2,
  getUserData,
  getToken
}